var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("b-container", { attrs: { fluid: "" } }, [
        _c("div", { staticClass: "title-notification" }, [
          _c("h3", [_vm._v("Fields Manually Hold/Release Portal")]),
          _c("h4", { staticClass: "warning" }, [
            _vm._v(
              "!!! *** Please make sure you know what are you doing *** !!!"
            )
          ]),
          _c("h4", { staticClass: "warning" }, [
            _vm._v(
              "!!! *** Wrongly hold/release my cause database crash *** !!!"
            )
          ])
        ]),
        _c("hr"),
        _c(
          "div",
          { staticClass: "username-rls-form" },
          [
            _c("br"),
            _c(
              "b-row",
              { staticClass: "my-1 release-form" },
              [
                _c(
                  "b-col",
                  {
                    staticStyle: { "text-align": "right" },
                    attrs: { sm: "3" }
                  },
                  [
                    _c("label", { attrs: { for: "username" } }, [
                      _vm._v("Username Fields")
                    ])
                  ]
                ),
                _c(
                  "b-col",
                  { attrs: { sm: "9" } },
                  [
                    _c("b-form-input", {
                      attrs: {
                        id: "username",
                        type: "text",
                        placeholder: "username"
                      },
                      model: {
                        value: _vm.username,
                        callback: function($$v) {
                          _vm.username = $$v
                        },
                        expression: "username"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "b-row",
              [
                _c("b-col", { attrs: { sm: "8", offset: "4" } }, [
                  _c("p", { staticClass: "entered" }, [
                    _vm._v("Entered: " + _vm._s(_vm.username))
                  ])
                ])
              ],
              1
            ),
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  {
                    staticStyle: { "text-align": "right" },
                    attrs: { sm: "8" }
                  },
                  [
                    _c(
                      "b-button",
                      {
                        attrs: { variant: "info" },
                        on: {
                          click: function($event) {
                            _vm.usernameCheck(1001)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                        Check\n                    "
                        )
                      ]
                    ),
                    _vm._v(" |\n                    "),
                    _c(
                      "b-button",
                      {
                        attrs: { variant: "warning" },
                        on: {
                          click: function($event) {
                            _vm.usernameCheck(1002)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                        Hold\n                    "
                        )
                      ]
                    ),
                    _vm._v(" |\n                    "),
                    _c(
                      "b-button",
                      {
                        attrs: { variant: "danger" },
                        on: {
                          click: function($event) {
                            _vm.usernameCheck(1003)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                        Release\n                    "
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c("br")
          ],
          1
        ),
        _c("hr"),
        _c("hr"),
        _c("hr"),
        _c(
          "div",
          { staticClass: "nric-fin-rls-form" },
          [
            _c("br"),
            _c(
              "b-row",
              { staticClass: "my-1 release-form" },
              [
                _c(
                  "b-col",
                  {
                    staticStyle: { "text-align": "right" },
                    attrs: { sm: "3" }
                  },
                  [
                    _c("label", { attrs: { for: "nric-fin" } }, [
                      _vm._v("NricFin Fields")
                    ])
                  ]
                ),
                _c(
                  "b-col",
                  { attrs: { sm: "9" } },
                  [
                    _c("b-form-input", {
                      attrs: {
                        id: "nric-fin",
                        type: "text",
                        placeholder: "Nric / Fin"
                      },
                      model: {
                        value: _vm.nricFin,
                        callback: function($$v) {
                          _vm.nricFin = $$v
                        },
                        expression: "nricFin"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "b-row",
              [
                _c("b-col", { attrs: { sm: "8", offset: "4" } }, [
                  _c("p", { staticClass: "entered" }, [
                    _vm._v("Entered: " + _vm._s(_vm.nricFin))
                  ])
                ])
              ],
              1
            ),
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  {
                    staticStyle: { "text-align": "right" },
                    attrs: { sm: "8" }
                  },
                  [
                    _c(
                      "b-button",
                      {
                        attrs: { variant: "info" },
                        on: {
                          click: function($event) {
                            _vm.nricFinCheck(2001)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                        Check\n                    "
                        )
                      ]
                    ),
                    _vm._v(" |\n                    "),
                    _c(
                      "b-button",
                      {
                        attrs: { variant: "warning" },
                        on: {
                          click: function($event) {
                            _vm.nricFinCheck(2002)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                        Hold\n                    "
                        )
                      ]
                    ),
                    _vm._v(" |\n                    "),
                    _c(
                      "b-button",
                      {
                        attrs: { variant: "danger" },
                        on: {
                          click: function($event) {
                            _vm.nricFinCheck(2003)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                        Release\n                    "
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c("br")
          ],
          1
        ),
        _c("hr"),
        _c("hr"),
        _c("hr"),
        _c(
          "div",
          { staticClass: "mstime-roomid-rls-form" },
          [
            _c("br"),
            _c(
              "b-row",
              { staticClass: "my-1 release-form" },
              [
                _c(
                  "b-col",
                  {
                    staticStyle: { "text-align": "right" },
                    attrs: { sm: "3" }
                  },
                  [
                    _c("label", { attrs: { for: "ms-time-room-id" } }, [
                      _vm._v("MS Time + RoomId")
                    ])
                  ]
                ),
                _c(
                  "b-col",
                  { attrs: { sm: "5" } },
                  [
                    _c(
                      "no-ssr",
                      [
                        _c("vue-ctk-date-time-picker", {
                          attrs: {
                            "no-weekends-days": "",
                            color: "#ba3030",
                            "minute-interval": 10
                          },
                          model: {
                            value: _vm.moduleSessionTimeRaw,
                            callback: function($$v) {
                              _vm.moduleSessionTimeRaw = $$v
                            },
                            expression: "moduleSessionTimeRaw"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "b-col",
                  { attrs: { sm: "4" } },
                  [
                    _c("b-form-select", {
                      attrs: {
                        id: "ms-time-room-id",
                        options: _vm.roomIds,
                        placeholder: "roomId"
                      },
                      model: {
                        value: _vm.roomId,
                        callback: function($$v) {
                          _vm.roomId = $$v
                        },
                        expression: "roomId"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "b-row",
              [
                _c("b-col", { attrs: { sm: "8", offset: "4" } }, [
                  _c("p", { staticClass: "entered" }, [
                    _vm._v(
                      "\n                        Entered:  " +
                        _vm._s(_vm.roomId) +
                        " + " +
                        _vm._s(
                          _vm.$moment(_vm.moduleSessionTimeRaw).format("X")
                        ) +
                        " "
                    ),
                    _c("br"),
                    _vm._v(
                      "\n                        = " +
                        _vm._s(
                          _vm.roomId +
                            _vm
                              .$moment(_vm.moduleSessionTimeRaw)
                              .format("X")
                              .toString()
                        ) +
                        "\n                    "
                    )
                  ])
                ])
              ],
              1
            ),
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  {
                    staticStyle: { "text-align": "right" },
                    attrs: { sm: "8" }
                  },
                  [
                    _c(
                      "b-button",
                      {
                        attrs: { variant: "info" },
                        on: {
                          click: function($event) {
                            _vm.mstimingWithRoomIdCheck(3001)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                        Check\n                    "
                        )
                      ]
                    ),
                    _vm._v(" |\n                    "),
                    _c(
                      "b-button",
                      {
                        attrs: { variant: "warning" },
                        on: {
                          click: function($event) {
                            _vm.mstimingWithRoomIdCheck(3002)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                        Hold\n                    "
                        )
                      ]
                    ),
                    _vm._v(" |\n                    "),
                    _c(
                      "b-button",
                      {
                        attrs: { variant: "danger" },
                        on: {
                          click: function($event) {
                            _vm.mstimingWithRoomIdCheck(3003)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                        Release\n                    "
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c("br")
          ],
          1
        )
      ]),
      _vm._v("\n    Manually Fields Releasing\n\n")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-53fcb111", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53fcb111","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/fieldsOperationPortal.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-53fcb111","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/fieldsOperationPortal.vue
// module chunks = 17